<div role="dialog" style="background-color: rgba(0, 0, 0, 0); display: block">
  <div class="modal-dialog" style="display: table">
    <div class="modal-content error-modal-content" style="padding: 20px">
      <div class="modal-body">
        <h4 class="head-modal">End Subscription?</h4>
        <hr class="modal-hr-line" />
        <p class="p_class">Please confirm that you want to unsubscribe from:</p>
        <ul class="p2 cancel-plan" *ngFor="let data of completeData">
          <li *ngIf="data.original !== data.change">
            {{ data.original - data.change }} {{ data.plans }} Collaborator Seat
          </li>

          <!-- <li *ngIf="outReach">Outreach</li> -->
        </ul>
        <ul class="p2 cancel-plan">
          <li *ngIf="outReach">Outreach</li>
        </ul>
        <span id="seats-id">
          <ul class="p2"></ul>
        </span>
        <span id="annual-seats-id">
          <ul class="p2"></ul>
        </span>
        <span id="month-seats-id">
          <ul></ul>
        </span>
        <span id="six-months-seats-id">
          <ul></ul>
        </span>
        <p class="p_class">
          Access will continue through the end of your billing&nbsp;cycle.
        </p>
      </div>
      <div style="text-align: right" class="btn_class">
        <button
          type="submit"
          (click)="unSubscribe()"
          class="btn gernal-btn yes_btn"
          data-dismiss="modal"
        >
          Yes
        </button>
        <button
          type="button"
          class="btn gernal-btn no-btn"
          data-dismiss="modal"
          (click)="noActionDIalog()"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
